import { DividerStyles } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${DividerStyles}
  :host([orientation='vertical']) {
    min-height: unset;
  }
`;
//# sourceMappingURL=divider.styles.js.map